"use client";
import SectionHeader from "@/components/common/section-header";
import React, { useEffect, useState } from "react";
import { cookiesManagerEN } from "@/assets/dictionaries/en/manage-content";
import { cookiesManagerES } from "@/assets/dictionaries/es/manage-content";

const CookiesIntro = () => {
  const [cookiesManageContent, setCookiesManageContent] =
    useState(cookiesManagerEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setCookiesManageContent(cookiesManagerES);
        break;
      case "EN":
      default:
        setCookiesManageContent(cookiesManagerEN);
        break;
    }
  }, []); // Only run on mount
  return (
    <section className="pt-16 px-page-xl">
      <SectionHeader>
        <div className="max-w-[240px] md:max-w-none">
          {cookiesManageContent.cookies_manager}
        </div>
      </SectionHeader>
      <div className="text-black text-xl text-left mt-8">
        {cookiesManageContent.cookies_manager_desc}
      </div>
    </section>
  );
};

export default CookiesIntro;
